import React, {Component} from "react";
import Dialog from '@mui/material/Dialog';
import {
    DialogActions,
    DialogTitle,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    TextField
} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import {connect} from "react-redux";
import {clear_cluster_share_error, create_cluster_share, remove_cluster_share} from "../../actions/clusters";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from '@mui/icons-material/Delete';
import SnackbarMessage from "../Custom/SnackbarMessage";
import Validator from "../../utilities/validator";
import withStyles from "@mui/styles/withStyles";

const styles = {
    title: {
        paddingBottom: 0
    },
    list: {
        minWidth: "250px"
    },
    dialogContent: {
        //paddingRight: 0
    },
    emailInput: {
        minWidth: "300px"
    }
}

class ClusterShareDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: true,
            email: "",
            emailTouched: false,
            openNew: false
        }
    }

    openNewDialog() {
        this.props.clear_cluster_share_error();
        this.setState({
            ...this.state,
            openNew: true,
            open: false
        });
    }

    closeNewDialog() {
        this.setState({
            ...this.state,
            openNew: false,
            open: true
        });
    }

    addUser() {
        this.props.create_cluster_share(this.props.cluster.id, this.state.email);
        this.setState({
            ...this.state,
            openNew: false,
            email: "",
            open: true
        });
    }

    onChange = e => this.setState({
        [e.target.name]: e.target.value,
        [e.target.name + 'Touched']: true
    });

    open_remove_prompt(id) {
        this.setState({
            ...this.state,
            removePrompt: id
        });
    }

    remove_close() {
        this.setState({
            ...this.state,
            removePrompt: false
        });
    }

    remove_agree() {
        this.props.remove_cluster_share(this.props.cluster.id, this.state.removePrompt);
        this.setState({
            ...this.state,
            removePrompt: false
        });
    }

    render() {
        const {classes} = this.props;

        let errors_array;
        if (this.props.share_error && "errors" in this.props.share_error) {
            errors_array = [];
            Object.keys(this.props.share_error.errors).map((field) => {
                errors_array = [...errors_array, ...this.props.share_error.errors[field]];
            });
        } else {
            errors_array = false;
        }
        const shared_with = this.props.clusters.find(cluster => cluster.id === this.props.cluster.id).shared_with;
        return <>
            <Dialog open={this.state.open} onClose={() => {
                this.props.handleClose();
                this.props.clear_cluster_share_error();
            }} aria-labelledby="form-dialog-title">
                <DialogTitle className={classes.title}>{this.props.cluster.title} is shared with</DialogTitle>
                <DialogContent className={classes.dialogContent}>

                    {this.props.share_error && this.props.share_error.message &&
                        <SnackbarMessage onClose={this.props.clear_cluster_share_error} type="error"
                                         message={this.props.share_error.message} autoHideDuration={null}
                                         anchorOrigin={false}
                                         style={{marginBottom: 30}}/>}
                    {this.props.share_error && !this.props.share_error.message && "errors" in this.props.share_error &&
                        <SnackbarMessage onClose={this.props.clear_cluster_share_error} type="error"
                                         message={errors_array.join(", ")} autoHideDuration={null}
                                         anchorOrigin={false}
                                         style={{marginBottom: 30}}/>}

                    <List disablePadding={true} className={classes.list}>
                        {Object.keys(shared_with).map(function (key, index) {
                            return (
                                <ListItem disableGutters={true} key={shared_with[key].email + "_" + index}>
                                    <ListItemText
                                        primary={shared_with[key].first_name + " " + shared_with[key].last_name}
                                        secondary={shared_with[key].email}
                                    />

                                    <ListItemSecondaryAction>
                                        <IconButton
                                            edge="end"
                                            aria-label="delete"
                                            onClick={() => this.open_remove_prompt(shared_with[key].id)}
                                            size="large">
                                            <DeleteIcon/>
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            );
                        }.bind(this))}
                    </List>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={this.openNewDialog.bind(this)}>
                        Add user
                    </Button>
                    <Button onClick={this.props.handleClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={Boolean(this.state.removePrompt)}
                onClose={this.remove_close.bind(this)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Are you sure you want to delete this sharing?"}</DialogTitle>
                <DialogActions>
                    <Button onClick={this.remove_close.bind(this)} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={this.remove_agree.bind(this)} color="secondary" autoFocus
                            variant="contained">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={this.state.openNew}>
                <DialogTitle className={classes.title}>Add user</DialogTitle>
                <DialogContent>
                    <TextField
                        variant="standard"
                        className={classes.emailInput}
                        margin="dense"
                        name="email"
                        label="E-mail"
                        type="email"
                        value={this.state.email}
                        fullWidth
                        onChange={this.onChange}
                        required
                        autoFocus={true}
                        error={this.state.emailTouched && !Validator.isEmailValid(this.state.email)}
                        helperText={this.state.emailTouched && !Validator.isEmailValid(this.state.email) ? "Please enter a valid e-mail" : ""}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.closeNewDialog.bind(this)} color="primary">
                        Close
                    </Button>
                    <Button onClick={this.addUser.bind(this)} color="primary"
                            disabled={!Validator.isEmailValid(this.state.email)}>
                        Add
                    </Button>
                </DialogActions>
            </Dialog>
        </>;
    }
}

const mapStateToProps = state => ({
    share_error: state.clusters.share_error,
    clusters: state.clusters.clusters,
});
export default withStyles(styles)(connect(
    mapStateToProps,
    {clear_cluster_share_error, remove_cluster_share, create_cluster_share}
)(ClusterShareDialog));
